export enum LicenseUserSeatType {
  Author,
  SME,
  Viewer
}
